import React from 'react';
import styled from 'styled-components';
import HtmlToReact from 'html-to-react';

const RichTextWrapper = styled.div`
  p {
    font-size: 18px;
    line-height: 28px;
  }

  ul, ol {
    max-width: 980px;
    padding: 0 25px;
    margin: 0 auto;
    max-height: 200px;
    overflow: auto;
    color: #666666;
    font-size: 20px;
    font-weight: 300;
    line-height: 28px;
  }

  h3 {
    font-size: 28px;
  }

  .block-img {
    position: relative;

    img {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
`;

function RichText({ input }) {
  const { primary } = input;
  const html = primary.text.html;
  const htmlParser = new HtmlToReact.Parser();
  const elem = htmlParser.parse(html);


  return (
    <RichTextWrapper>
      {elem}
    </RichTextWrapper>
  );
}

export { RichText };
